export { defaultLocale, i18n, locales, parseLocaleString } from "./locales";
export { LocaleProvider, useLocale } from "./use-locale";
